import { default as React } from 'react';

import { FormFields, PostalCodeAndCityFormField, ValidationIssue } from './FormInterfaces';
import { getValidationIssue } from './GetValidationIssue';
import { PostalCodeInput } from './PostalCodeInput';
import { getCity, getPostalCode } from './PostalCodeInputUtil';

export interface PostalCodeFormInputProps {
    readonly input: PostalCodeAndCityFormField;
    readonly inputs: FormFields;
    readonly autocompleteUrl: string;
    readonly name: string;
    readonly value?: string;
    readonly setValue: (value: string, name: string, errors: ValidationIssue[]) => void;
    readonly setWasActive: (name: string) => void;
}

export const PostalCodeFormInput = (props: PostalCodeFormInputProps) => {
    const getValues = (value: string): { city: string; postNumber: string } => {
        return {
            city: getCity(value),
            postNumber: getPostalCode(value)
        };
    };

    const setFieldsValues = (value: string, errors: ValidationIssue[]) => {
        const { city, postNumber } = getValues(value);
        props.setValue(`${postNumber} ${city}`.trim(), props.name, errors);
        props.setValue(city, props.input.city, getValidationIssue(props.inputs[props.input.city], props.inputs, city));
        props.setValue(postNumber, props.input.postalCode, getValidationIssue(props.inputs[props.input.postalCode], props.inputs, postNumber));
    };

    const setWasActive = () => {
        props.setWasActive(props.input.city);
        props.setWasActive(props.input.postalCode);
        props.setWasActive(props.name);
    };

    const hasErrors = () => {
        const issues = props.input.validationIssues;
        const postalCodeIssues = props.inputs[props.input.postalCode].validationIssues;
        const cityIssues = props.inputs[props.input.city].validationIssues;

        return !!(
            (props.input.wasActive &&
                ((issues && issues.length > 0) ||
                    (postalCodeIssues && (postalCodeIssues?.length ?? 0) > 0) ||
                    (cityIssues && (cityIssues?.length ?? 0 > 0)))) ??
            false
        );
    };

    return (
        <PostalCodeInput
            key={props.name}
            onBlur={setWasActive}
            validationIssues={props.input.validationIssues}
            onChange={setFieldsValues}
            autocompleteUrl={props.autocompleteUrl}
            label={
                <label>
                    {props.input.displayName}
                    <span className="NewForm__FieldRequired">{props.input.validation?.required?.value && ' *'}</span>
                </label>
            }
            displayName={props.input.displayName}
            value={props.value}
            hasError={hasErrors()}
        />
    );
};
